import {
  reactQueryDelete,
  reactQueryGet,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { PaywallFailure } from "@/react/types";

export interface ProcessorError {
  code?: string;
  decline_code?: string;
  message: string;
}

interface AttemptCancelResponse {
  failure?: PaywallFailure;
  navigate?: boolean;
}

const show = (fingerprint: string) =>
  reactQueryGet(internalApi.paywallCheckout.attempts.show(fingerprint));

const cancel = (
  attemptId: number,
  processorError?: ProcessorError,
): Promise<AttemptCancelResponse> =>
  reactQueryDelete<AttemptCancelResponse, { processor_error?: ProcessorError }>(
    internalApi.paywallCheckout.attempts.destroy(attemptId),
    processorError ? { processor_error: processorError } : undefined,
  );

export const paywallCheckoutAttemptsApi = {
  show,
  cancel,
};
